import * as React from "react";
import { createStyles, makeStyles, Paper, Chip } from "@material-ui/core";
import {
    domain,
    getUserFromStorage,
    RelodeTheme,
    Text,
} from "../..";
import { TagMatchType } from "core/src/domain";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            paper: {
                padding: theme.spacing(2),
            },
            header: {
                marginBottom: 15,
            },
            chipRow: {
                padding: theme.spacing(1, 0),
                display: "flex",
                flexFlow: "row wrap",
                gap: 10,
            }
        }),
    { name: "BenefitsView" }
);

interface BenefitsViewProps {
    benefits: TagMatchType[];
}

export const BenefitsView = (props: BenefitsViewProps) => {
    const { benefits } = props;
    const classes = useStyles({});
    const user = getUserFromStorage();
    const isClient = user.role === domain.UserRole.Client || user.role === domain.UserRole.ClientAdmin ;

    return (
        <Paper elevation={isClient ? 0 : 1 } className={classes.paper}>
            <Text variant="h2" gutterBottom>
                benefits
            </Text>
            <div className={classes.chipRow}> 
                {
                    benefits.map(x => (
                        <Chip
                            variant="outlined"
                            color="primary"
                            label={x.tagName}
                            key={x.tagId}
                        />
                    ))
                }
            </div>
        </Paper>
    );
};